import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import useCreateBadge from './useCreateBadge';
import useDeleteBadge from './useDeleteBadge';
import useUpdateBadge from './useUpdateBadge';
export default function useUpdatePlaylistBadge(playlistId, playlistBadge) {
  var _useCreateBadge = useCreateBadge({
      hasSuccessAlert: true
    }),
    createBadge = _useCreateBadge.createBadge,
    isCreateBadgeLoading = _useCreateBadge.isLoading;
  var _useUpdateBadge = useUpdateBadge({
      badgeId: playlistBadge === null || playlistBadge === void 0 ? void 0 : playlistBadge.id,
      parentPlaylistId: playlistId,
      hasSuccessAlert: true
    }),
    updateBadge = _useUpdateBadge.updateBadge,
    isUpdateBadgeLoading = _useUpdateBadge.isLoading;
  var _useDeleteBadge = useDeleteBadge({
      badgeId: playlistBadge === null || playlistBadge === void 0 ? void 0 : playlistBadge.id,
      parentPlaylistId: playlistId,
      hasSuccessAlert: true
    }),
    deleteBadge = _useDeleteBadge.deleteBadge,
    isDeleteBadgeLoading = _useDeleteBadge.isLoading;
  var isLoading = isCreateBadgeLoading || isUpdateBadgeLoading || isDeleteBadgeLoading;
  function updatePlaylistBadge(_x) {
    return _updatePlaylistBadge.apply(this, arguments);
  }
  function _updatePlaylistBadge() {
    _updatePlaylistBadge = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var contentId, badgeId, imageId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            contentId = _ref.contentId, badgeId = _ref.badgeId, imageId = _ref.imageId;
            if (!(imageId === undefined)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            if (!(!badgeId && imageId)) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", createBadge({
              imageId: imageId,
              contentIds: [contentId]
            }));
          case 5:
            if (!badgeId) {
              _context.next = 10;
              break;
            }
            if (!(imageId === null)) {
              _context.next = 8;
              break;
            }
            return _context.abrupt("return", deleteBadge());
          case 8:
            _context.next = 10;
            return updateBadge({
              imageId: imageId,
              contentIds: [contentId]
            });
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _updatePlaylistBadge.apply(this, arguments);
  }
  return {
    updatePlaylistBadge: updatePlaylistBadge,
    isLoading: isLoading
  };
}